App.DefaultRoute = Em.Route.extend
  beforeModel: ->
    @transitionTo 'index'